import { createFileRoute, Link } from '@tanstack/react-router';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowUpRight, Settings, ExternalLink, BarChart3 } from 'lucide-react';
import { useRedirects } from '@/hooks/useRedirects';
import { useAnalytics } from '@/hooks/useAnalytics';

export const Route = createFileRoute('/admin/')({
  component: AdminOverview,
});

function AdminOverview() {
  const { redirects } = useRedirects();
  const { totalViews, uniqueSessions, isLoading } = useAnalytics(30);
  const activeRedirects = redirects.filter((r) => r.is_active).length;

  const cards = [
    { title: 'Statistiken', description: 'Besucheranalysen & Traffic', icon: BarChart3, link: '/admin/analytics' as const, stat: isLoading ? '...' : `${totalViews} Aufrufe / ${uniqueSessions} Besucher (30 Tage)` },
    { title: 'Weiterleitungen', description: 'URL-Redirects verwalten', icon: ArrowUpRight, link: '/admin/redirects' as const, stat: `${activeRedirects} aktiv` },
    { title: 'Einstellungen', description: 'Allgemeine Einstellungen', icon: Settings, link: '/admin/settings' as const, stat: null as string | null },
  ];

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold">Dashboard</h1>
        <p className="text-muted-foreground mt-2">Willkommen im Admin-Bereich. Hier können Sie Ihre Website verwalten.</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {cards.map((card) => (
          <Link key={card.link} to={card.link}>
            <Card className="h-full hover:shadow-md transition-shadow cursor-pointer group">
              <CardHeader>
                <div className="flex items-center justify-between">
                  <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center">
                    <card.icon className="h-5 w-5 text-primary" />
                  </div>
                  <ExternalLink className="h-4 w-4 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
                <CardTitle className="mt-4">{card.title}</CardTitle>
                <CardDescription>{card.description}</CardDescription>
              </CardHeader>
              {card.stat && (
                <CardContent>
                  <p className="text-2xl font-bold text-primary">{card.stat}</p>
                </CardContent>
              )}
            </Card>
          </Link>
        ))}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Schnellzugriff</CardTitle>
          <CardDescription>Häufig verwendete Funktionen</CardDescription>
        </CardHeader>
        <CardContent className="space-y-2">
          <Link to="/admin/redirects" className="flex items-center gap-2 text-sm text-primary hover:underline">
            <ArrowUpRight className="h-4 w-4" />Neue Weiterleitung hinzufügen
          </Link>
          <Link to="/" target="_blank" className="flex items-center gap-2 text-sm text-primary hover:underline">
            <ExternalLink className="h-4 w-4" />Website öffnen
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
